import React, { memo } from 'react';

import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';

import { useEventDetail } from 'components/Pages/Admin/TabsMyEvents/context/EventDetail';
import CustomLoader from 'components/Shared/CustomLoader';
import ReactPlaceholder from 'react-placeholder/lib';

import EventWidget from './components/EventWidget';
import * as S from './styles';

const EventCart = memo(() => {
  const { loading } = useEventDetail();

  const handleTutorial = () => {
    window.open('', '_blank').focus();
  };

  return (
    <S.Container>
      <ReactPlaceholder customPlaceholder={<CustomLoader />} ready={!loading}>
        <p className='event-cart-description'>Para utilizar, basta seguir os seguintes passos:</p>

        <li>Criar uma “div” em sua página</li>
        <li>Copiar o script abaixo </li>
        <li>Colar em sua página, na seção de scripts</li>
        <li>No campo “selector” do script, colocar o mesmo “id” da div criada anteriormente.</li>

        <p className='event-cart-custom-card'>Também é possível fazer customizações no carrinho</p>
        <a
          href='https://ajuda.eduzz.com/hc/pt-br/articles/4413080195483-Personalização-da-página-de-vendas-para-eventos-Orbit-Pages-'
          target='_blank'
          rel='noopener noreferrer'
          className='event-cart-link desktop'
        >
          Veja um tutorial que preparamos pra você <ArrowRightOutlined />
        </a>
        <p onClick={handleTutorial} className='event-cart-link mobile'>
          Veja este tutorial <ArrowRightOutlined />
        </p>

        <EventWidget />
      </ReactPlaceholder>
    </S.Container>
  );
});

export default EventCart;
